import type { IssueStatus, IssueType, UserFlowSeverity } from "../types";

export const getIssueStatusColor = (status: IssueStatus) => {
  switch (status) {
    case "open":
      return "error";
    case "resolved":
      return "success";
    case "closed":
      return "default";
    case "reopened":
      return "warning";
    default:
      return "default";
  }
};

export const getIssueSeverityColor = (severity: UserFlowSeverity) => {
  switch (severity) {
    case "critical":
      return "error";
    case "high":
      return "warning";
    case "medium":
      return "info";
    case "low":
      return "default";
    default:
      return "default";
  }
};

export const getIssueTypeColor = (type: IssueType) => {
  switch (type) {
    case "bug":
      return "error";
    case "feature_request":
      return "primary";
    case "improvement":
      return "info";
    default:
      return "default";
  }
};
